import * as e from 'app/constants/TourBuilderEvents';
// import { Type } from 'app/constants/TourPoints';
import mapUtils from 'app/libs/Utils/mapUtils';

import { useMediator } from '../useMediator';
import { useTimestamp } from '../../../../Utility/Service/keepTimestamp.service';

const NAME_ROADS_LIST_DEVIDER = 2; // the less number the more routes included in the Shaping pounts

// const highwayList = [
//   'unpaved',
//   'residential',
//   'unclassified',
//   'tertiary',
//   'secondary',
//   '',
// ];

const dataPoly = () => {
  let fullPolyStr = null;
  let dashedPolyDelay = null;

  const [addToProgress, removeFromProgress] = useTimestamp();
  const [getMediator, setMediator, destroyMediator] = useMediator();

  const showPolyStrOnMap = () => {
    const latLngs = mapUtils.polyStrToArr(fullPolyStr);
    getMediator().notify(e.TB_SHOW_POLY_STR_ON_MAP, { latLngs });
  };

  const removePolyByPointId = (pointId) => {
    getMediator().notify(e.TB_POLY_DRIVE_MAP_CHANGE_POLY, {
      latLngs: [],
      pointId,
    });
  };

  const changePointPolyOnMap = (obj) => {
    getMediator().notify(e.TB_POLY_DRIVE_MAP_CHANGE_POINT_POLY, obj);
  };

  const movePointPolyOnMap = (obj) => {
    getMediator().notify(e.TB_POLY_DRIVE_MAP_MOVE_POINT_POLY, obj);
  };

  const updatePointPuthById = (pointId, route) => {
    const timestamp = removeFromProgress();
    getMediator().notify(e.TB_UPDATE_POINT_ROUTE_PATH, { pointId, route });
    if (timestamp)
      getMediator().notify(e.TB_SAVE_PART_DATA_IN_REDUX_USE_TIMESTAMP, {
        timestamp,
      });
  };

  const setShapeUnpavedData = (pointId, obj) => {
    getMediator().notify(e.TB_UPDATE_POINT_SHAPING_POINTS, { ...obj, pointId });
  };

  const updatePartDistDur = (partId, { distance, duration }) => {
    getMediator().notify(e.ATP_UPDATE_DISTANCE_DURATION_PART_BY_ID, {
      partId,
      distance,
      duration,
    });
  };

  const isLatLngsValid = (latLngs) =>
    latLngs &&
    latLngs.length &&
    Array.isArray(latLngs[0]) &&
    Array.isArray(latLngs[latLngs.length - 1]);

  const removePolyStrOnMap = () =>
    fullPolyStr
      ? getMediator().notify(e.TB_SHOW_POLY_STR_ON_MAP, { latLngs: [] })
      : null;

  const getCoeficient = (highway) => {
    let num = 1;
    switch (highway) {
      case 'unpaved':
        num = 6;
        break;
      case 'residential':
        num = 5;
        break;
      case 'unclassified':
        num = 4;
        break;
      case 'tertiary':
        num = 3;
        break;
      case 'secondary':
        num = 2;
        break;
      case 'motorway':
        num = 0;
        break;

      default:
        break;
    }
    return num;
  };

  const ifExcludedRoutes = (route) => {
    return route === 'shuttle_train';
  };

  const shpapeUnpavedPreparation = (routeSteps) => {
    const shapingList = {};
    const allShapeArr = [];
    const roadTypes = {};
    let roughShape = [];
    let unpavedParts = [];

    if (routeSteps.length > 3) {
      const steps = routeSteps.slice();
      steps.pop();
      steps.shift(); // remove first and last elements

      const roadsShape = {};

      steps.forEach((el) => {
        let highway = '';
        const { distance = 0, name, intersections = [] } = el;
        const firstSection = intersections[0];
        if (firstSection && firstSection.classes) {
          highway = [...firstSection.classes[0]];
        }
        if (!ifExcludedRoutes(highway)) {
          const coef = Math.round(distance * getCoeficient(highway));
          roadsShape[coef] = { distance, name, highway };
        }
      });

      const orderedByDist = Object.keys({ ...roadsShape })
        .sort()
        .reduce((obj, key) => {
          obj[key] = roadsShape[key];
          return obj;
        }, {});

      const nameRoadsList = Object.values(orderedByDist).reverse();

      const len = Math.floor(nameRoadsList.length / NAME_ROADS_LIST_DEVIDER);

      roughShape = nameRoadsList.map((el) => el.distance).slice(0, len);
    }

    const isItStartUnpavedRoad = (classes) =>
      classes && classes.indexOf('unpaved') > -1;

    const fixFive = (num) => Math.round(num * 100000) / 100000;

    const countStartEndUpnavedPositions = ({ classes, location }) => {
      if (classes && classes.length > 0) {
        roadTypes[classes[0]] = location;
      }

      let type = 'basic';
      if (isItStartUnpavedRoad(classes)) {
        type = 'unpaved';
      }
      const [lat, lng] = location;
      const loc = [fixFive(lng), fixFive(lat)];

      return { [type]: loc };
    };

    unpavedParts = routeSteps
      .map(({ intersections, geometry, name, distance }, it) => {
        let listUnpavedCoordsPosintions = [];
        const unpavedLatLngs = mapUtils.decodePath(geometry);
        const len = unpavedLatLngs ? unpavedLatLngs.length : 0;

        if (intersections && intersections.length > 0) {
          listUnpavedCoordsPosintions = intersections.map(
            countStartEndUpnavedPositions
          );
        }

        const step = len / 4;
        let index = Math.floor(step) + 1;

        if (index <= 2) {
          index = Math.floor(len / 2) + 1;
        }

        const indexDouble = Math.floor(step * 2) + 1;

        if (
          index > 2 &&
          index < len - 1 &&
          roughShape.indexOf(distance) > -1 &&
          it &&
          it < routeSteps.length - 1
        ) {
          const coords = unpavedLatLngs[index];
          shapingList[name] = allShapeArr.length;
          allShapeArr.push(coords);
        }

        if (
          indexDouble > 2 &&
          indexDouble < len - 1 &&
          roughShape.indexOf(distance) > -1 &&
          it &&
          it < routeSteps.length - 1
        ) {
          const coords = unpavedLatLngs[indexDouble];
          allShapeArr.push(coords);
        }

        const unpavedSteps = [];

        const getPos = ([lat, lng]) =>
          unpavedLatLngs.findIndex(
            ([polyLat, polyLng]) => polyLat === lat && polyLng === lng
          );

        const ln = listUnpavedCoordsPosintions.length;

        for (let i = 0; i < ln; i++) {
          let pos = -1;
          const part = listUnpavedCoordsPosintions[i] || {};
          const loc = part.unpaved;
          if (pos === -1 && loc) {
            pos = getPos(loc);
          }
          const basicPoly = part.basic;
          if (pos > -1 && basicPoly) {
            const oneStep = unpavedLatLngs.slice(pos, getPos(basicPoly));
            unpavedSteps.push(oneStep);
            pos = -1;
          }
          if (pos > -1) {
            const nextPart = listUnpavedCoordsPosintions[i + 1] || {};
            const endLoc = nextPart.basic || nextPart.unpaved;
            const endPos = endLoc && getPos(endLoc);
            const end = endPos > -1 ? endPos + 1 : -1;
            if (end === -1) {
              const leftToEnd = [
                ...unpavedLatLngs.slice(pos, -1),
                ...unpavedLatLngs.slice(-1),
              ];
              unpavedSteps.push(leftToEnd);
            } else {
              const leftToEnd = [...unpavedLatLngs.slice(pos, end)];
              unpavedSteps.push(leftToEnd);
            }
          }
        }

        if (unpavedSteps.length > 0) {
          return unpavedSteps;
        }

        return '';
      })
      .filter((val) => !!val);
    return { allShapeArr, shapingList, unpavedParts };
  };

  const parsePoly = (
    event,
    { dashedPoly, pointId, partId, isEdit, oncePointData, ...obj }
  ) => {
    const route = {
      path: '',
      distance: 0,
      duration: 0,
    };
    let shapeData = {
      unpavedParts:
        oncePointData && oncePointData.unpaved_parts
          ? oncePointData.unpaved_parts
          : [],
      shapingList:
        oncePointData && oncePointData.shaping_points
          ? oncePointData.shaping_points
          : {},
      allShapeArr: [],
    };

    let isNewGeneratedData = false;
    if (dashedPolyDelay) clearTimeout(dashedPolyDelay);

    if (event) {
      if (event === 'cancel') {
        return;
      }

      const {
        routeGeometry,
        routeSummary,
        routeSteps,
        detectedPoints = [],
      } = event;

      route.path = routeGeometry;
      route.distance = routeSummary.totalDistance;
      route.duration = routeSummary.totalTime;

      if (
        !oncePointData ||
        (oncePointData &&
          !oncePointData.unpaved_parts &&
          !oncePointData.shaping_points)
      ) {
        isNewGeneratedData = true;
        shapeData = shpapeUnpavedPreparation(routeSteps);
      }

      const latLngs = mapUtils.decodePath(routeGeometry);
      if (isLatLngsValid(latLngs)) {
        changePointPolyOnMap({
          ...obj,
          latLngs,
          pointId,
          isEdit,
          partId,
          detectedPoints,
        });
      } else if (dashedPoly && dashedPoly.length > 2) {
        changePointPolyOnMap({ latLngs: dashedPoly, isEdit, pointId, partId });
      }
    } else {
      dashedPolyDelay = setTimeout(() => {
        if (dashedPoly && dashedPoly.length > 2)
          changePointPolyOnMap({
            latLngs: dashedPoly,
            isEdit,
            pointId,
            partId,
          });
      }, 500);
    }
    if (pointId) {
      const { unpavedParts, shapingList, allShapeArr } = shapeData;
      updatePointPuthById(pointId, route);
      setShapeUnpavedData(pointId, {
        unpavedParts,
        shapingList,
        allShapeArr,
        isNewGeneratedData,
      });
    }
    if (partId) {
      updatePartDistDur(partId, route);
    }
    if (obj.rtRlCb) {
      obj.rtRlCb();
    }
  };

  const delyList = {};

  const displayPoly = ({
    point,
    isEdit,
    avoid = {},
    isShapingVisible,
    oncePointData,
  }) => {
    const { id } = point;
    if (!id) return;
    if (delyList[id]) {
      clearTimeout(delyList[id]);
    }
    const pointId = point.getId();
    if (point.isCoordsValid()) {
      delyList[id] = setTimeout(() => {
        addToProgress();
        const options = {};
        options.overview = 'full';
        options.path = `${point.getPrevCoordStr()};${point.getCoordStr()}`;
        const dashedPoly = [
          'dashed',
          point.getPrevCoordStr().split(',').reverse(),
          point.getCoordStr().split(',').reverse(),
        ];

        mapUtils.getOSMDirectionsService(options, parsePoly, {
          isEdit,
          pointId,
          dashedPoly,
          avoid,
          isShapingVisible,
          oncePointData,
        });
      }, 400);
    } else {
      removePolyByPointId(pointId);
    }
  };

  const parseTemporaryPoly = (ev, { isEdit, pointId, ...obj }) => {
    if (ev && ev !== 'cancel') {
      const { routeGeometry, routeSteps } = ev;
      const shapeData = shpapeUnpavedPreparation(routeSteps);
      let unpr = {};
      if (pointId) {
        const { unpavedParts } = shapeData;
        unpr = obj.avoid.unpaved ? unpavedParts : {};
      }
      const latLngs = mapUtils.decodePath(routeGeometry);
      movePointPolyOnMap({ latLngs, isEdit, pointId, unpavedParts: unpr });
    }
  };

  const showTemporaryPolyByPoint = ({ pointId, from, to, avoid }) => {
    const options = {};
    options.path = `${from.lng},${from.lat};${to}`;
    const dashedPoly = [[from.lat, from.lng], to.split(',').reverse()];
    mapUtils.getOSMDirectionsService(options, parseTemporaryPoly, {
      isEdit: true,
      pointId,
      dashedPoly,
      avoid,
    });
  };

  const showPolyByPoint = (obj) => {
    if (obj.point) {
      displayPoly(obj);
    } else {
      console.error('Point was not found');
    }
  };

  const load = (
    polyStr,
    isPreviewPolyAvailable = false,
    wasEditModeChanged
  ) => {
    if (wasEditModeChanged) {
      if (fullPolyStr) {
        // if aproximate poly exists and changed only edit mode we need create polilynes for each point
        removePolyStrOnMap();
        fullPolyStr = null;
        return true;
      }
    }
    if (isPreviewPolyAvailable && polyStr) {
      fullPolyStr = polyStr;
      showPolyStrOnMap();
      return false;
    }
    return true;
  };

  const clear = () => {
    removePolyStrOnMap();
    mapUtils.cancelRespByTopic('address');
  };

  const destroy = () => {
    clear();
    destroyMediator();
  };

  // functions for polylines on the map of all parts page
  const partsPolyData = {};

  const dropPolyOnMap = (partId) => {
    getMediator().notify(e.TB_POLY_DRIVE_MAP_CHANGE_POLY, {
      latLngs: [],
      partId,
    });
  };

  const addPartPolyData = (partId, puth) => {
    partsPolyData[partId] = puth;
  };

  const removePartPolyData = (partId) => {
    delete partsPolyData[partId];
    dropPolyOnMap(partId);
  };

  const getDataForMap = (partId, avoid = {}) => ({
    isEdit: false,
    partId,
    avoid,
  });

  const prepareOptions = (coords) => {
    const options = {};
    options.overview = 'simplified';
    options.path = coords.join(';');
    return options;
  };

  const updatePartPolyData = (partId, pointPuth, isFirst) => {
    dropPolyOnMap(partId);
    const arrPuth = partsPolyData[partId];
    if (isFirst) {
      arrPuth[0] = pointPuth;
    } else {
      const lastPointPos = arrPuth.length - 1;
      arrPuth[lastPointPos] = pointPuth;
    }
    mapUtils.getOSMDirectionsService(
      prepareOptions(arrPuth),
      parsePoly,
      getDataForMap(partId)
    );
  };

  const showPartPolyline = (puth, partId, avoid) => {
    if (!partId) {
      console.error('Part id is absent in method showPartPolyline');
      return;
    }
    if (puth) {
      if (puth.length > 1) {
        addPartPolyData(partId, puth);
        mapUtils.getOSMDirectionsService(
          prepareOptions(puth),
          parsePoly,
          getDataForMap(partId, avoid)
        );
      }
    } else {
      removePartPolyData(partId);
    }
  };

  /* RideTwister */
  const addRtWaypoints = (points) => {
    getMediator().notify(e.TB_SHOW_RT_WAYPOINTS, { points });
  };

  const parseRtPoly = (event, { pointId, isEdit, oncePointData, ...obj }) => {
    const route = {
      path: '',
      distance: 0,
      duration: 0,
    };

    let shapeData = {
      unpavedParts:
        oncePointData && oncePointData.unpaved_parts
          ? oncePointData.unpaved_parts
          : [],
      shapingList:
        oncePointData && oncePointData.shaping_points
          ? oncePointData.shaping_points
          : {},
      allShapeArr: [],
    };

    let isNewGeneratedData = false;

    if (event) {
      if (event === 'cancel') {
        return;
      }

      const { routeGeometry, routeSummary, routeSteps, waypoints = [] } = event;

      route.path = routeGeometry;
      route.distance = routeSummary.totalDistance;
      route.duration = routeSummary.totalTime;

      if (
        !oncePointData ||
        (oncePointData &&
          !oncePointData.unpaved_parts &&
          !oncePointData.shaping_points)
      ) {
        isNewGeneratedData = true;
        shapeData = shpapeUnpavedPreparation(routeSteps);
      }
      const latLngs = mapUtils.decodePath(routeGeometry);
      if (isLatLngsValid(latLngs)) {
        changePointPolyOnMap({
          ...obj,
          latLngs: [],
          pointId,
          isEdit,
        });
      }
      if (waypoints) {
        addRtWaypoints(waypoints);
      }
    }
    if (pointId) {
      const { unpavedParts, shapingList, allShapeArr } = shapeData;
      updatePointPuthById(pointId, route);
      setShapeUnpavedData(pointId, {
        unpavedParts,
        shapingList,
        allShapeArr,
        isNewGeneratedData,
      });
    }
    if (obj.rtRlCb) {
      obj.rtRlCb();
    }
  };

  const delyRtList = {};

  const showRtPoly = ({
    point,
    isEdit,
    rtParams,
    avoid = {},
    isShapingVisible,
    oncePointData,
    rtRlCb,
  }) => {
    const { id } = point;
    if (!id) return;
    if (delyRtList[id]) {
      clearTimeout(delyRtList[id]);
    }
    const pointId = point.getId();
    if (rtParams.coorditanes) {
      delyRtList[id] = setTimeout(() => {
        addToProgress();
        const options = { ...rtParams };
        options.overview = 'full';

        mapUtils.twisterServiceOSRM(options, parseRtPoly, {
          isEdit,
          pointId,
          avoid,
          isShapingVisible,
          oncePointData,
          rtRlCb,
        });
      }, 400);
    }
  };

  return Object.freeze({
    setMediator,
    load,
    showPolyByPoint,
    showTemporaryPolyByPoint,
    removePolyByPointId,
    showPartPolyline,
    updatePartPolyData,
    showRtPoly,
    clear,
    destroy,
  });
};

export default dataPoly;
